import { __decorate, __metadata } from "tslib";
import { Sim } from '@dooboostore/simple-boot';
export var VoiceService;
(function (VoiceService) {
    VoiceService.SYMBOL = Symbol.for('VoiceService');
})(VoiceService || (VoiceService = {}));
// 팩토리: Accommodation 패턴
export default (container) => {
    let VoiceServiceImpl = class VoiceServiceImpl {
        constructor() {
            Object.defineProperty(this, "selectedVoice", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: null
            });
            Object.defineProperty(this, "isPlayingWord", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "isPlayingScript", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            if (typeof window !== 'undefined')
                this.initVoices();
        }
        isValidVoice(voice) {
            if (!voice)
                return false;
            try {
                return typeof voice.name === 'string' && typeof voice.lang === 'string';
            }
            catch {
                return false;
            }
        }
        selectBestEnglishVoice(voices) {
            const priorities = ['Samantha', 'Alex', 'Victoria', 'Google US English', 'Google UK English Female', 'Microsoft Zira Desktop', 'Microsoft David Desktop'];
            for (const name of priorities) {
                const v = voices.find(v => v.name.includes(name) && v.lang.startsWith('en'));
                if (v && this.isValidVoice(v))
                    return v;
            }
            return voices.find(v => v.lang.startsWith('en') && v.localService) || voices.find(v => v.lang.startsWith('en')) || null;
        }
        initVoices() {
            if (!('speechSynthesis' in window))
                return;
            const load = () => {
                const voices = speechSynthesis.getVoices();
                if (voices.length > 0)
                    this.selectedVoice = this.selectBestEnglishVoice(voices);
            };
            load();
            speechSynthesis.onvoiceschanged = load;
        }
        speakWord(word, onEnd) {
            if (!('speechSynthesis' in window))
                return;
            // 이미 출력 중인 음성(단어·문장 불문)은 끊고 새로 출력
            this.stopSpeech();
            const clean = word.replace(/[,.":!?;]/g, '').trim();
            if (!clean)
                return;
            const u = new SpeechSynthesisUtterance(clean);
            u.lang = 'en-US';
            u.rate = 0.9;
            u.pitch = 1.0;
            u.volume = 0.9;
            if (this.selectedVoice && this.isValidVoice(this.selectedVoice)) {
                try {
                    u.voice = this.selectedVoice;
                }
                catch { }
            }
            this.isPlayingWord = true;
            u.onend = () => { this.isPlayingWord = false; if (onEnd)
                onEnd(); };
            u.onerror = () => { this.isPlayingWord = false; };
            speechSynthesis.speak(u);
        }
        speakScript(text, onStart, onEnd, onError) {
            if (!('speechSynthesis' in window))
                return;
            this.stopSpeech();
            const clean = text.replace(/[""]/g, '"').trim();
            if (!clean)
                return;
            const u = new SpeechSynthesisUtterance(clean);
            u.lang = 'en-US';
            u.rate = 0.85;
            u.pitch = 1.0;
            u.volume = 0.9;
            if (this.selectedVoice && this.isValidVoice(this.selectedVoice)) {
                try {
                    u.voice = this.selectedVoice;
                }
                catch { }
            }
            this.isPlayingScript = true;
            u.onstart = () => { this.isPlayingScript = true; if (onStart)
                onStart(); };
            u.onend = () => { this.isPlayingScript = false; if (onEnd)
                onEnd(); };
            u.onerror = () => { this.isPlayingScript = false; if (onError)
                onError(); };
            speechSynthesis.speak(u);
        }
        stopSpeech() {
            if ('speechSynthesis' in window)
                speechSynthesis.cancel();
            this.isPlayingScript = false;
            this.isPlayingWord = false;
        }
    };
    VoiceServiceImpl = __decorate([
        Sim({ symbol: VoiceService.SYMBOL, container: container }),
        __metadata("design:paramtypes", [])
    ], VoiceServiceImpl);
    return VoiceServiceImpl;
};
